<ng-template #content let-modal>
  @let localTerms = terms();

  <div class="modal-header">
    @if (localTerms) {
      <h2 class="modal-title unbold">
        {{ "terms_condition" | translate }}
      </h2>
    } @else {
      <h2 class="modal-title unbold">
        {{ "politicas_de_privacidad" | translate }}
      </h2>
    }
  </div>
  <div class="modal-body text-center">
    <div
      class="terminos-content mb-3 text-start"
      [innerHTML]="localTerms ? termsCondition() : privacyPolicy()"
    ></div>
    <button (click)="modal.close('Close click')" class="light-blue mb-2">
      {{ "$salir_terminos" | translate }}
    </button>
    <br />
  </div>
</ng-template>
